import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Ng2ImgMaxService } from 'ng2-img-max';

@Component({
  selector: 'rx-upload-zone',
  templateUrl: './rx-upload-zone.component.html',
  styleUrls: ['./rx-upload-zone.component.scss'],
})
export class RxUploadZoneComponent implements OnInit {
  @ViewChild('zone', { read: ElementRef }) zone: ElementRef;

  @Output() checkedChange = new EventEmitter<any>();
  @Output() droppedFiles = new EventEmitter<any>();

  @Input() multiple = false;
  @Input() imageSize: { width: number; height: number } = <any>null;

  public files: any[] = [];

  public error = false;

  constructor(
    private sanitizer: DomSanitizer,
    private ng2ImgMaxService: Ng2ImgMaxService,
  ) {}

  ngOnInit() {}

  onActive() {
    this.zone.nativeElement.click();
  }

  onChange(e) {
    if (e.target.files.length === 0) {
      return;
    }
    this.onError(false);
    this.files = [];
    const file = e.target.files[0];
    e.preventDefault();
    e.stopPropagation();
  }

  onError(e) {
    this.error = e;
  }

  setupReader() {
    const formData: FormData = new FormData();
    formData.append('photo', this.files[0].file);
    // this.payload.formData = formData;
  }

  remove() {
    this.files = [];
    // this.payload.formData = null;
  }

  filesDropped(files: any[]): void {
    this.files = files;
    // this.setupReader();
  }

  getFiles(e) {
    this.checkedChange.emit(e);
  }

  onDroppedFiles(event) {
    if (this.imageSize) {
      this.ng2ImgMaxService
        .resize(event, this.imageSize.width, this.imageSize.height)
        .subscribe((result) => {
          this.droppedFiles.emit([new File([result], result.name, result)]);
        });
    } else {
      this.droppedFiles.emit(event);
    }
  }
}
